import { ReactNode, Component } from 'react';
import { DatadogClient } from '@workivate/tho-web-shared';
type Props = {
  children: ReactNode;
  fallback: ReactNode;
  tags?: Array<{
    tag: string;
    value: string;
  }>;
};

type State = {
  error: Error | null | undefined;
};

const NoFallbackError = () => (
  <div>{'Fallback UI for ErrorBoundary is missing'}</div>
);

class DataDogErrorBoundary extends Component<Props, State> {
  static displayName = 'DataDogErrorBoundary';
  state = { error: null };

  componentDidCatch(error: Error, info: { componentStack: string }) {
    this.setState({ error });
    const { tags = [] } = this.props;
    const errorTags = tags.reduce((acc: string[], curr) => {
      return acc.concat(`${curr.tag}:${curr.value}`);
    }, []);

    const renderingError = new Error(error?.message);
    renderingError.name = 'ReactRenderingError';
    renderingError.stack = info.componentStack;
    // Add cause as a custom property since it's not available in ES2021
    (renderingError as any).cause = error;

    DatadogClient.addError(renderingError);
    DatadogClient.logMessage(`FE USL Error: ${error?.message}`, {
      tags: errorTags,
    });
  }

  render() {
    const { children, fallback } = this.props;

    if (!fallback) {
      return <NoFallbackError />;
    }

    if (this.state.error) {
      return fallback;
    }
    return children;
  }
}

export default DataDogErrorBoundary;
